import { render, staticRenderFns } from "./DpApplicationApplicantFormList.vue?vue&type=template&id=cfc85618&scoped=true&"
import script from "./DpApplicationApplicantFormList.vue?vue&type=script&lang=js&"
export * from "./DpApplicationApplicantFormList.vue?vue&type=script&lang=js&"
import style0 from "./DpApplicationApplicantFormList.vue?vue&type=style&index=0&id=cfc85618&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc85618",
  null
  
)

export default component.exports